import { cliSimpleGit } from './cli-simple-git.js';

export async function isGitRepoDirectory(dirPath: string): Promise<boolean> {
  try {
    return await cliSimpleGit(dirPath).checkIsRepo();
  } catch {
    return false;
  }
}
